import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import SelectAsync from 'react-select/async';
import Factor from "./Factor";
import Remittance from "./Remittance";

export default class StuffCardex extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            systemModuleId: 4,
            moduleAccessStatus: 1,
            filters: {
                warehouseId: this.getDefaultGuid(),
                warehouseName: '',
                stuffId: this.getDefaultGuid(),
                stuffName: '',
                priceMode: 5,
                ownerName: '',
                warehouseLocation: ''
            },
            page: 1,
            per_page: 30,
            phrase: '',
            controllerName: 'report',
            menuId: 50
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);

        var stuffId = this.getQueryString("stuffId");
        if (!this.isBlank(stuffId)) {
            this.state.filters.stuffId = stuffId;
        }
    }
    async refreshData(e, action = "list", outputFormat = "json", pageReset = true) {
        if (!this.isNull(e)) e.preventDefault();

        if (pageReset) this.state.page = 1;

        this.httpPost("api/v1/" + this.state.controllerName + "/" + action, {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            sort: this.state.sort ? this.state.sort : '',
            paging: this.state.paging ? this.state.paging : true,
            counting: this.state.counting ? this.state.counting : true,
            filters: this.state.filters,
            outputFormat
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    if (data.message) {
                        this.showErorrMessage(data.message);
                    }

                    this.setState({
                        selectedIds: [],
                        loading: false
                    });
                }
                else {
                    if (outputFormat == 'excel') this.downloadExcel(data.bs64);
                    if (outputFormat == 'pdf') this.downloadPDF(data.bs64);
                    if (outputFormat == "json") {
                        this.state.filters.stuffName = data.stuffName;
                        this.state.data = data;
                    }
                    this.setState({
                        loading: false
                    });
                }
            })
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData(null, 'stuff/cardex');
            });
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.refreshData(null, 'stuff/cardex');
    }
    setStuff(e) {
        this.state.filters.stuffId = e.value;
        this.state.filters.stuffName = e.label;
    }
    setWarehouse(e) {
        this.state.filters.warehouseId = e.value;
        this.state.filters.warehouseName = e.label;
    }
    onShowFactor(id, type, stuffId) {
        this.removeKeyDown();
        this.showComponents({ component: <Factor HighlightedStuffs={[stuffId]} Type={type} Caller={this} Id={id} /> });
    }
    onShowRemittance(record) {
        this.removeKeyDown();
        if (!this.isNull(record.remittanceParentId))
            this.showComponents({ component: <Remittance HighlightedStuffs={[record.stuffId]} IO={3} Caller={this} Id={record.remittanceParentId} /> });
        else
            this.showComponents({ component: <Remittance HighlightedStuffs={[record.stuffId]} IO={record.io} Caller={this} Id={record.remittanceId} /> });
    }
    saveChecked(idx, checked) {
        this.state.data.records.forEach((f, index) => {
            if (index === idx) f.checked = checked;
        });

        this.setState({ data: this.state.data });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">کاردکس کالاها</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.refreshData(e, "stuff/cardex", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e, "stuff/cardex")}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap" style={{ "min-width": "230px" }}>
                                                <SelectAsync
                                                    defaultValue={this.state.filters.warehouseId != this.defaultGuid() ? [{ value: this.state.filters.warehouseId, label: this.state.filters.warehouseName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب انبار"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadWarehousesOptions(inputValue, callback)}
                                                    onChange={e => this.setWarehouse(e)}
                                                />
                                            </div>
                                            <div className="form-wrap" style={{ "min-width": "230px" }}>
                                                <SelectAsync
                                                    defaultValue={this.state.filters.stuffId != this.defaultGuid() ? [{ value: this.state.filters.stuffId, label: this.state.filters.stuffName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب کالا"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadStuffsOptions(inputValue, callback)}
                                                    onChange={e => this.setStuff(e)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.priceMode} className="form-control" onChange={e => this.state.filters.priceMode = parseInt(e.target.value)}>
                                                    <option value="1">نحوه ارزش گذاری</option>
                                                    <option value="2">میانگین</option>
                                                    <option value="3">FIFO</option>
                                                    <option value="4">LIFO</option>
                                                    <option value="5">فروش</option>
                                                </select>
                                            </div>
                                            {this.state.data.global.company.enableWarehouseOwner === true && <div className="form-wrap">
                                                <input defaultValue={this.state.filters.ownerName} onChange={e => this.state.filters.ownerName = e.target.value} type="text" className="form-control" placeholder="مالک کالا" />
                                            </div>}
                                            {this.state.data.global.company.enableWarehouseLocation === true && <div className="form-wrap">
                                                <input defaultValue={this.state.filters.warehouseLocation} onChange={e => this.state.filters.warehouseLocation = e.target.value} type="text" className="form-control" placeholder="جایگاه" />
                                            </div>}
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e, "stuff/cardex")} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ ردیفی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره سند</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره فاکتور</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نوع سند</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تاریخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">انبار</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">طرح حساب</span></div>
                                            {this.state.data.global.company.enableWarehouseOwner === true && <div className="nk-tb-col text-center"><span className="sub-text">مالک</span></div>}
                                            {this.state.data.global.company.enableWarehouseLocation === true && <div className="nk-tb-col text-center"><span className="sub-text">جایگاه</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">تعداد وارده</span></div>
											{this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col text-center"><span className="sub-text">تعداد وارده<br />فرعی</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">فی وارده</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تعداد صادره</span></div>
                                            {this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col text-center"><span className="sub-text">تعداد صادره<br />فرعی</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">فی صادره</span></div>
                                            {this.state.filters.priceMode !== 1 && <div className="nk-tb-col text-center"><span className="sub-text">مبلغ برآورد</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">موجودی</span></div>
                                            {this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col text-center"><span className="sub-text">موجودی<br />فرعی</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">ارزش</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item " + (record.checked ? "highlighted" : "")}>
                                                <div className="nk-tb-col text-center">
                                                    <a className="hand text-primary" onClick={e => this.onShowRemittance(record)}>{record.number}</a>
                                                </div>
                                                <div className="nk-tb-col text-center">
                                                    {!this.isNull(record.factorId) && <a className="hand text-primary" onClick={e => this.onShowFactor(record.factorId, record.factorType, record.stuffId)}>{record.factorNumber}</a>}
                                                </div>
                                                <div className="nk-tb-col">
                                                    {record.io === 1 && <a onClick={e => this.onShowRemittance(record)} className="hand sub-text text-center text-success">رسید</a>}
                                                    {record.io === 2 && <a onClick={e => this.onShowRemittance(record)} className="hand sub-text text-center text-danger">حواله</a>}
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.date}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.warehouseName}</span>
                                                </div>                                                
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.personName}</span>
                                                </div>
                                                {this.state.data.global.company.enableWarehouseOwner === true && <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.ownerName}</span>
                                                </div>}
                                                {this.state.data.global.company.enableWarehouseLocation === true && <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.warehouseLocationName}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.in}</span>
                                                </div>
                                                {this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.inModulus}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.inPrice)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.out}</span>
                                                </div>
                                                {this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.outModulus}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.outPrice)}</span>
                                                </div>
                                                {this.state.filters.priceMode !== 1 && <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.outputPrice)}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.remain}</span>
                                                </div>
                                                {this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.FixedPointNumber(record.remainModulus,3)}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{this.money(record.remainPrice)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <input type="checkbox" defaultChecked={record.checked} onChange={e => this.saveChecked(index, e.target.checked)} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}